<template>
  <div class="xv_view" id="Office_view">
    <div class="xv_top">
      <div>
        <label class="xv_view_title">{{ this.name }}</label>
      </div>
      <div class="xv_actions">
        <span>Status :</span>
        <!-- <span class="main_status_1">Ok</span> -->
        <span class="main_status_2">Closed</span>
      </div>
    </div>
    <div class="xv_tabs">
      <div>
        <b-tabs content-class="mt-3">
          <b-tab title="Profile" active>
            <div class="tab_profile">
              <div class="row">
                <div class="col-7">
                  <div class="pro_section">
                    <label>Name</label>
                    <input type="text" value="Microsoft" :disabled="profile_edit == false" />
                  </div>
                  <div class="pro_section">
                    <label>Address</label>
                    <input type="text" value="11 Hougang" :disabled="profile_edit == false" />
                  </div>
                  <div class="pro_section row">
                    <div class="col-6">
                      <label>State</label>
                      <input type="text" value="Hougang" :disabled="profile_edit == false" />
                    </div>
                    <div class="col-6">
                      <label>City</label>
                      <input type="text" value="Hougang" :disabled="profile_edit == false" />
                    </div>
                  </div>
                  <div class="pro_section row">
                    <div class="col-6">
                      <label>Pin</label>
                      <input type="text" value="538789" :disabled="profile_edit == false" />
                    </div>
                    <div class="col-6">
                      <label>Country</label>
                      <input type="text" value="Singapore" :disabled="profile_edit == false" />
                    </div>
                  </div>

                  <div class="pro_section">
                    <label>GPS Location</label>
                    <input
                      type="text"
                      value="40.741895, -73.989308"
                      :disabled="profile_edit == false"
                    />
                  </div>
                  <div class="pro_section">
                    <label>Contact number</label>
                    <input type="text" value="+65 76544356" :disabled="profile_edit == false" />
                  </div>
                  <div class="pro_section">
                    <label>Admin</label>

                    <select name id :disabled="profile_edit == false">
                      <option value="1">Jasmine Morgan</option>
                      <option value="1" selected>Joseph Davis</option>
                      <option value="1">Haleema Andrews</option>
                      <option value="1">Yasmine Hoffman</option>
                      <option value="1">Anthony Cook</option>
                    </select>
                  </div>

                  <div class="row pro_section">
                    <div class="col-4">
                      <label>Status</label>
                      <select name id :disabled="profile_edit == false">
                        <option value="1">Ok</option>
                        <option value="2" selected>Closed</option>
                      </select>
                    </div>
                    <div class="col-4">
                      <label>Till when</label>
                      <input type="text" :disabled="profile_edit == false" />
                    </div>
                    <div class="col-4">
                      <label>Comments</label>
                      <input type="text" :disabled="profile_edit == false" />
                    </div>
                  </div>
                </div>

                <div class="col-5 text-right">
                  <div v-if="profile_edit == false">
                    <button class="pro_btn m_r sec_btn" @click="profile_edit = true">
                      <span class="mdi mdi-pencil"></span>
                    </button>
                    <button class="pro_btn sec_btn" @click="delete_popup()">
                      <span class="mdi mdi-trash-can"></span>
                    </button>
                  </div>

                  <div v-if="profile_edit == true">
                    <button class="pro_btn m_r save save_btn" @click="profile_edit = false">Save</button>
                    <button class="pro_btn cancel delete_btn" @click="profile_edit = false">Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab title="Locations">
            <div class="location_tab">
              <div class="xv_table">
                <div class="xv_table_title">
                  <div>
                    <span>Markers</span>
                  </div>
                  <div>
                    <button class="main_btn" @click="new_marker()">
                      Add Marker
                      <span class="mdi mdi-plus-thick"></span>
                    </button>
                  </div>
                </div>

                <table class="office_location_table">
                  <thead>
                    <tr>
                      <th style="width:15%">Name</th>
                      <th style="width:15%;text-align:center">Desc</th>
                      <th style="width:15%;text-align:center">Type</th>
                      <th style="width:15%;text-align:center">Checkins</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <span @click="update_marker()">Meeting Room</span>
                      </td>
                      <td>5th floor</td>
                      <td>
                        <span class="mdi mdi-bluetooth-audio"></span>
                      </td>
                      <td>14</td>
                    </tr>
                    <tr>
                      <td>
                        <span @click="update_marker()">Board Room</span>
                      </td>
                      <td>2th floor</td>
                      <td>
                        <span class="mdi mdi-qrcode-scan"></span>
                      </td>
                      <td>20</td>
                    </tr>
                    <tr>
                      <td>
                        <span @click="update_marker()">Parking</span>
                      </td>
                      <td>0th floor</td>
                      <td>
                        <span class="mdi mdi-bluetooth-audio"></span>
                      </td>
                      <td>14</td>
                    </tr>
                    <tr>
                      <td>
                        <span @click="update_marker()">Food court</span>
                      </td>
                      <td>8th floor</td>
                      <td>
                        <span class="mdi mdi-bluetooth-audio"></span>
                      </td>
                      <td>14</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-tab>
          <b-tab title="Alerts">
            <div class="alert_tab">
              <div class="xv_table">
                <div class="xv_table_title">
                  <div>
                    <span>4 Alerts for today</span>
                  </div>
                  <div>
                    <button class="sec_btn" @click="table_filter()">
                      Filter
                      <span class="mdi mdi-filter-menu"></span>
                    </button>
                  </div>
                </div>

                <div class="filter_wrap">
                  <div class="left_filter" v-if="left_filter == true">
                    <div class="header_section top">
                      <div>
                        <span class="main_title">
                          Filter
                          <span class="mdi mdi-filter-menu"></span>
                        </span>
                      </div>
                      <div>
                        <span class="option">Reset</span>
                      </div>
                    </div>
                    <div class="section">
                      <div class="header_section">
                        <div>
                          <span class="title">Date</span>
                        </div>
                        <div>
                          <span class="option">Clear</span>
                        </div>
                      </div>

                      <div class="content">
                        <div class="xv_datepicker">
                          <span class="mdi mdi-calendar-month"></span>
                          <vc-date-picker
                            mode="range"
                            v-model="selectedDate"
                            :popover="{ visibility: 'click' }"
                            :input-props="{
                              class: 'picker_input',
                              placeholder: 'Select dates',
                              readonly: true
                            }"
                            :masks="{ input: 'DD/MM/YY' }"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="section">
                      <div class="header_section">
                        <div>
                          <span class="title">Severity</span>
                        </div>
                        <div>
                          <span class="option">Clear</span>
                        </div>
                      </div>

                      <div class="content">
                        <div class="filter_checkbox">
                          <div class="check">
                            <b-form-checkbox id="checkbox-5" name="checkbox-5"></b-form-checkbox>
                          </div>
                          <div>
                            <span class="check_label">High</span>
                          </div>
                        </div>
                        <div class="filter_checkbox">
                          <div class="check">
                            <b-form-checkbox id="checkbox-6" name="checkbox-6"></b-form-checkbox>
                          </div>
                          <div>
                            <span class="check_label">Medium</span>
                          </div>
                        </div>
                        <div class="filter_checkbox">
                          <div class="check">
                            <b-form-checkbox id="checkbox-7" name="checkbox-7"></b-form-checkbox>
                          </div>
                          <div>
                            <span class="check_label">Low</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="section">
                      <div class="header_section">
                        <div>
                          <span class="title">Source</span>
                        </div>
                        <div>
                          <span class="option">Clear</span>
                        </div>
                      </div>

                      <div class="content">
                        <multiselect
                          v-model="multiselect"
                          :options="[
                            'Borad room',
                            'Meeting room',
                            'Food court',
                            'Parking'
                          ]"
                          :multiple="true"
                        ></multiselect>
                      </div>
                    </div>

                    <div class="section">
                      <div class="header_section">
                        <div>
                          <span class="title">Type</span>
                        </div>
                        <div>
                          <span class="option">Clear</span>
                        </div>
                      </div>

                      <div class="content">
                        <div class="filter_checkbox">
                          <div class="check">
                            <b-form-checkbox id="checkbox-1" name="checkbox-1"></b-form-checkbox>
                          </div>
                          <div class="check_label">
                            <span>High Temperature</span>
                          </div>
                        </div>
                        <div class="filter_checkbox">
                          <div class="check">
                            <b-form-checkbox id="checkbox-2" name="checkbox-2"></b-form-checkbox>
                          </div>
                          <div>
                            <span class="check_label">Travel History</span>
                          </div>
                        </div>
                        <div class="filter_checkbox">
                          <div class="check">
                            <b-form-checkbox id="checkbox-3" name="checkbox-3"></b-form-checkbox>
                          </div>
                          <div>
                            <span class="check_label">Quarantine Order</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <table class="alerts_table">
                    <thead>
                      <tr>
                        <th style>Date</th>
                        <th style="text-align:center">Employee</th>
                        <th style="text-align:center">Type</th>
                        <th style="text-align:center">Source</th>
                        <th style="text-align:center">Action Taken</th>
                        <th style="text-align:center">Advise</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <span>02-Jan-2020 10:30am</span>
                        </td>
                        <td>
                          <span class="e_name" @click="view_employee">Joseph Davis</span>
                        </td>
                        <td>
                          <span class="alert_1" id="type_ht_1">High Temperature</span>
                          <b-popover target="type_ht_1" triggers="hover" placement="bottom">
                            Sed eu justo ullamcorper, hendrerit urna quis,
                            varius lorem.
                          </b-popover>
                        </td>
                        <td>
                          <span>Main Office Lobby A</span>
                        </td>
                        <td>
                          <b-dropdown split split-href="#" text="Deny Access" class="xv_drop m-2">
                            <b-dropdown-item href="#">Refer BioSecurity</b-dropdown-item>
                            <b-dropdown-item href="#">Dismiss Alert</b-dropdown-item>
                          </b-dropdown>
                        </td>
                        <td>
                          <span class="alert_advise">WFH 7 days</span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>02-Jan-2020 10:30am</span>
                        </td>
                        <td>
                          <span class="e_name" @click="view_employee">Franklin Clinton</span>
                        </td>
                        <td>
                          <span class="alert_2" id="type_th">Travel History</span>
                          <b-popover target="type_th" triggers="hover" placement="bottom">
                            Sed eu justo ullamcorper, hendrerit urna quis,
                            varius lorem.
                          </b-popover>
                        </td>
                        <td>
                          <span>Health Declaration</span>
                        </td>
                        <td>
                          <b-dropdown split split-href="#" text="Deny Access" class="xv_drop m-2">
                            <b-dropdown-item href="#">Refer BioSecurity</b-dropdown-item>
                            <b-dropdown-item href="#">Dismiss Alert</b-dropdown-item>
                          </b-dropdown>
                        </td>
                        <td>
                          <span class="alert_advise">WFH 14 days</span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>02-Jan-2020 10:30am</span>
                        </td>
                        <td>
                          <span class="e_name" @click="view_employee">Haleema Andrews</span>
                        </td>
                        <td>
                          <span class="alert_3" id="type_qo">Quarantine Order</span>
                          <b-popover target="type_qo" triggers="hover" placement="bottom">
                            Sed eu justo ullamcorper, hendrerit urna quis,
                            varius lorem.
                          </b-popover>
                        </td>
                        <td>
                          <span>System</span>
                        </td>
                        <td>
                          <b-dropdown split split-href="#" text="Deny Access" class="xv_drop m-2">
                            <b-dropdown-item href="#">Refer BioSecurity</b-dropdown-item>
                            <b-dropdown-item href="#">Dismiss Alert</b-dropdown-item>
                          </b-dropdown>
                        </td>
                        <td>
                          <span class="alert_advise">Alerted Govt</span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>02-Jan-2020 10:30am</span>
                        </td>
                        <td>
                          <span class="e_name" @click="view_employee">Jasmine Morgan</span>
                        </td>
                        <td>
                          <span class="alert_1" id="type_pq">Proximity Quaratine</span>
                          <b-popover target="type_pq" triggers="hover" placement="bottom">
                            Sed eu justo ullamcorper, hendrerit urna quis,
                            varius lorem.
                          </b-popover>
                        </td>
                        <td>
                          <span>System</span>
                        </td>

                        <td>
                          <b-dropdown split split-href="#" text="Deny Access" class="xv_drop m-2">
                            <b-dropdown-item href="#">Refer BioSecurity</b-dropdown-item>
                            <b-dropdown-item href="#">Dismiss Alert</b-dropdown-item>
                          </b-dropdown>
                        </td>
                        <td>
                          <span class="alert_advise">WFH 14 days</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab title="History">
            <div class="alert_tab">
              <div class="xv_table">
                <table class="office_history_table">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th style="text-align:center">Status</th>
                      <th style="text-align:center">Comments</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>20-Jan-2020 10:30am</td>
                      <td class="status_ok">
                        <span>Closed</span>
                      </td>
                      <td class="status_ok">
                        <span>
                          Closed for Deep Cleaning from 06-March-2020 to
                          14-Mar-2020 due to case
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>10-Jan-2020 09:00pm</td>
                      <td class="status_cl">
                        <span>ReOpened</span>
                      </td>
                      <td class="status_ok">
                        <span>ReOpened after deep cleaning</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-tab>
          <template v-slot:tabs-end></template>
        </b-tabs>
      </div>
    </div>
    <!-- New marker -->
    <modal name="new_marker" transition="pop-out" :width="600" height="auto">
      <newMarker></newMarker>
    </modal>
    <!-- Update marker -->
    <modal name="update_marker" transition="pop-out" :width="600" height="auto">
      <updateMarker></updateMarker>
    </modal>
    <!-- Delete popup -->
    <modal name="delete_popup" transition="pop-out" :width="450" height="auto">
      <deletePopup delete_text="Do you really want to delete this office? This cannot be undone."></deletePopup>
    </modal>
  </div>
</template>

<script>
import newMarker from "../new_marker/new_marker.vue";
import updateMarker from "../update_marker/update_marker.vue";
import deletePopup from "../../../layout/delete_popup/delete_popup.vue";

export default {
  name: "Office_view",
  components: {
    newMarker,
    updateMarker,
    deletePopup
  },
  data() {
    return {
      name: "",
      left_filter: false,
      profile_edit: false,
      multiselect: null
    };
  },
  // watch: {
  //   "$route.params.id": function() {
  //     this.name = this.$route.params.id.slice(1);
  //   }
  // },
  created() {
    this.name = this.$route.params.id.slice(1);
  },
  methods: {
    update_office: function() {
      this.$modal.show("update_office");
    },
    new_marker: function() {
      this.$modal.show("new_marker");
    },
    update_marker: function() {
      this.$modal.show("update_marker");
    },
    delete_popup: function() {
      this.$modal.show("delete_popup");
    },

    table_filter: function() {
      if (this.left_filter == false) {
        this.left_filter = true;
      } else {
        this.left_filter = false;
      }
    },
    view_employee: function() {
      this.$router.push("employees");
    }
  }
};
</script>
